/* eslint-disable react/forbid-prop-types */
import React, { Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import * as contentActions from "../../redux/actions/contentActions";
import ContentForm from "./Content-form";
import LoadingSpinner from "../common/LoadingSpinner";
import Preloader from "../Preloader/Preloader";
import Modal from "../common/modal/Modal";
import ContentSection from "./Content-section";

class ContentEditContainer extends React.Component {
  componentDidMount() {
    console.log("Mounted component");
    const { actions } = this.props;
    actions.fetchContent(this.props.match.params.id);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.response !== prevProps.response) {
      this.state = { key: "description" };
      const { actions, response } = this.props;
      if (response !== null) {
      }
      actions.fetchContents();
    }

    if (this.state.content == null && this.props.content != null) {
      this.setState({
        content: this.props.content
      });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      content: null,
      section: {
        body: "",
        category: "",
        heading: "",
        position: 1,
      },
      showModal: false,
    };
    this.myToast = null;
  }

  handleChange = (event) => {
    const { value, name } = event.target;

    let currentContent = this.state.content;

    if (name === "uploads") {
      currentContent.uploads.push(value);
    } else if (name === "active" || name == "showDetails") {
      currentContent = { ...this.state.content, [name]: event.target.checked };
    } else {
      currentContent = { ...this.state.content, [name]: value };
    }

    this.setState({ content: currentContent });
  };

  handleDelete = (index) => {
    if (window.confirm("Do you want to delete this file?")) {
      let currentContent = this.state.content;
      currentContent.uploads.splice(index, 1);
      this.setState({ content: currentContent });
    }
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { actions } = this.props;
    let content = this.state.content;
    //delete content.created;
    delete content.user;
    content.cover = {id: content.cover.id};
    actions.updateContent(content);
    if (event !== null) {
      this.myToast = toast.success(`The content has been updated successfully`);
    }
  };

  closeModal = () => {
    const { actions } = this.props;
    actions.hideModal();
    this.setState({showModal: false});
  };

  handleChangeSection = (event) => {
    const { value, name } = event.target;
    let currentSection = this.state.section;

    currentSection = { ...this.state.section, [name]: value };
    this.setState({ section: currentSection });
  };

  handleSubmitSection = (event) => {
    event.preventDefault();
    this.setState(prevState => {
      const updatedContent = {
        ...prevState.content,
        sections: [...prevState.content.sections, prevState.section]
      };
      return { content: updatedContent };
    });
    this.closeModal();
  };

  handleDeleteSection = (index) => {
    if (window.confirm("Do you want to delete this section?")) {
      this.setState(prevState => {
        const updatedSections = prevState.content.sections.slice(); // Create a shallow copy of the sections array
        updatedSections.splice(index, 1); // Modify the copied array
        const updatedContent = {
          ...prevState.content,
          sections: updatedSections
        };
        return { content: updatedContent };
      });
    }
  };

  handleNewSection = (event) => {
    event.preventDefault();
    this.setState({showModal: true});
  };

  render() {
    const { isLoading = true, error = "", uploads = [] } = this.props;
    const {section, content = {}, showModal = false} = this.state;
    const visibility = showModal ? "visible" : "invisible";
    return isLoading || content == null ? (
      <>
        <Preloader/>
      </>
    ) : (
      <Fragment>
        {showModal ? (
          <Modal
            visibility={visibility}
            modalContentId="newOrderItemId"
            modalId="newOrderId"
            closeModal={this.closeModal}
            title="New Section">
            <ContentSection handleChange={this.handleChangeSection} handleSubmit={this.handleSubmitSection} content={section} />
          </Modal>
        ) : null}
        <div className="blue-strip">
          <div className="row">
            <div className="col-10">EDIT CONTENT</div>
            <div className="col-2">
              <div className="edit-content">
                <button
                  className="custom-btn d-inline-flex align-items-center m-2 m-sm-0"
                  onClick={this.handleNewSection}
                >
                  New Section
                </button>                
              </div>
            </div>
          </div>
        </div>
        <ContentForm
          content={content}
          handleSubmit={this.handleSubmit}
          handleChange={this.handleChange}
          isLoading={isLoading}
          handleDelete={this.handleDelete}
          handleDeleteSection={this.handleDeleteSection}
        />
      </Fragment>
    );
  }
}

ContentEditContainer.propTypes = {
  content: PropTypes.object,
  response: PropTypes.object,
  error: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  isLoadingContents: PropTypes.bool.isRequired,
  showModal: PropTypes.bool.isRequired,
  totalRecords: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
  return {
    totalRecords: state.contents.totalRecords,
    users: state.contents.users,
    error: state.contents.error,
    isLoadingContents: state.contents.isLoadingContents,
    isLoading: state.contents.isLoading,
    showModal: state.contents.showModal,
    content: state.contents.content,
    response: state.contents.response,
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(contentActions, dispatch) };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContentEditContainer);
